import { render, staticRenderFns } from "./MentionBox.vue?vue&type=template&id=4f50dba1&scoped=true&"
import script from "./MentionBox.vue?vue&type=script&lang=js&"
export * from "./MentionBox.vue?vue&type=script&lang=js&"
import style0 from "./MentionBox.vue?vue&type=style&index=0&id=4f50dba1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f50dba1",
  null
  
)

export default component.exports